import { render, staticRenderFns } from "./ConfigureSettingsNewTemp.vue?vue&type=template&id=07deb742&scoped=true"
import script from "./ConfigureSettingsNewTemp.vue?vue&type=script&lang=js"
export * from "./ConfigureSettingsNewTemp.vue?vue&type=script&lang=js"
import style0 from "./ConfigureSettingsNewTemp.vue?vue&type=style&index=0&id=07deb742&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07deb742",
  null
  
)

export default component.exports